import React, { Fragment, useState } from 'react';
import classNames from 'classnames';
import { FCP } from 'types';

import { generateRandomKey } from 'utils';

import styles from './expandableSection.module.css';

interface ExpandableSectionProps extends FCP {
  sectionHeader?: string | React.ReactNode;
  /**
   * Pass the header as function that receives the open state and the icon.
   * Useful for positioning the icon anywhere within the header.
   */
  functionHeader?: (open: boolean, expandIcon: React.ReactNode) => React.ReactNode;
  sectionBody?: string | React.ReactNode;
  initialState?: boolean;
  expandIcon?: React.ReactNode;
  animateBody?: boolean;
  rightAlignIcon?: boolean;
}

const ExpandableSection = (props: ExpandableSectionProps) => {
  const {
    sectionHeader = '',
    functionHeader,
    sectionBody = '',
    children,
    initialState = true,
    expandIcon,
    animateBody = false,
    rightAlignIcon = true,
  } = props;

  const [expand, setExpand] = useState(initialState);

  const toggleSection = () => {
    setExpand((prev) => !prev);
  };

  const getIcon = (expandState: boolean, customIcon: React.ReactNode) => {
    return customIcon ? (
      <i
        className={classNames(
          { 'ml-auto': rightAlignIcon },
          styles[expandState ? 'customIconOpen' : 'customIconClosed']
        )}
      >
        {customIcon}
      </i>
    ) : (
      <i className={classNames({ 'ml-auto': rightAlignIcon }, expandState ? 'icon-angle-up' : 'icon-angle-down')} />
    );
  };

  return (
    <section id={generateRandomKey()} className={classNames('w-100', 'z-ml-0')}>
      <div
        className={classNames(
          'd-flex align-items-start cursor-pointer',
          styles['contextTitlesHead']
        )}
        onClick={toggleSection}
        onKeyDown={(e) => [' ', 'Enter'].includes(e.key) && toggleSection()}
        tabIndex={0}
        role="button"
      >
        {functionHeader
          ? functionHeader(expand, getIcon(expand, expandIcon))
          : (
            <>
              {sectionHeader}
              {getIcon(expand, expandIcon)}
            </>
          )
        }
      </div>

      {expand && (
        <div className={classNames({ [styles.animateBody]: animateBody })}>
          {sectionBody || children}
        </div>
      )}
    </section>
  );
};

export default ExpandableSection;
